import { FC } from 'react'

import { colors } from '../../theme'
import { ActionButtonProps } from '../ActionButton'
import { DayButtonProps } from '../DayButton'
import HighlightSelector, {
  HighlightSelectorProps,
} from '../FormElements/HighlightSelector'
import { PushPWAFunctionnalitySectionProps } from '../PushPWAFunctionnalitySection'
import { PushPWATutoSectionProps } from '../PushPWATutoSection'
import { PushMessageProps } from '../PushMessage'
import { ECollapsable } from '../Collapsable/types'

import * as SC from './styled'

export type PlanningPlannerSectionProps = {
  headerTitle?: {
    start: string
    end: string
  }
  title?: string
  headerDaySelector: HighlightSelectorProps
  actionButtons?: ActionButtonProps[]
  days?: DayButtonProps[]
  isEarlierPlanning?: boolean
  hideLunchOnWeekDays?: boolean
  hideDinnerOnWeekDays?: boolean
  isSelectedDayAWeekEndDay?: boolean
  pushNotification?: PushPWAFunctionnalitySectionProps & {
    shouldDisplay?: boolean
  }
  pushInstallAndroid?: PushPWAFunctionnalitySectionProps & {
    shouldDisplay?: boolean
  }
  pushInstallAndroidFirefox?: PushPWATutoSectionProps & {
    shouldDisplay?: boolean
  }
  pushInstalliOS?: PushPWATutoSectionProps & {
    shouldDisplay?: boolean
  }
  pushMessage?: PushMessageProps & {
    shouldDisplay?: boolean
  }
}

const PlanningPlannerSection: FC<PlanningPlannerSectionProps> = ({
  headerTitle,
  title,
  headerDaySelector,
  actionButtons,
  days,
  isEarlierPlanning = false,
  pushNotification,
  pushInstallAndroid,
  pushInstallAndroidFirefox,
  pushInstalliOS,
  pushMessage,
}) => {
  return (
    <SC.Collapse
      backgroundColor={colors.wildSand}
      header={
        headerTitle ? (
          <SC.SectionTitle>
            <SC.CustomHighlight
              backgroundColor={colors.greenMint}
              color={colors.pureBlack}
              text={headerTitle.start}
            />
            <HighlightSelector {...headerDaySelector} />
            <SC.CustomHighlight
              backgroundColor={colors.greenMint}
              color={colors.pureBlack}
              text={headerTitle.end}
            />
          </SC.SectionTitle>
        ) : (
          title && (
            <SC.SectionTitle>
              <SC.CustomHighlight
                backgroundColor={colors.greenMint}
                color={colors.pureBlack}
                text={title}
              />
            </SC.SectionTitle>
          )
        )
      }
      isCollapsable={ECollapsable.NONE}
      isOpenOnInit
    >
      <SC.Inner>
        {pushNotification && pushNotification.shouldDisplay && (
          <SC.PushPWAFunctionnality {...pushNotification} />
        )}
        {pushInstallAndroid && pushInstallAndroid.shouldDisplay && (
          <SC.PushPWAFunctionnality {...pushInstallAndroid} />
        )}
        {pushInstallAndroidFirefox &&
          pushInstallAndroidFirefox.shouldDisplay && (
            <SC.PushPWATuto {...pushInstallAndroidFirefox} />
          )}
        {pushInstalliOS && pushInstalliOS.shouldDisplay && (
          <SC.PushPWATuto {...pushInstalliOS} />
        )}
        {pushMessage && pushMessage.shouldDisplay && (
          <SC.CustomPushMessage {...pushMessage} />
        )}
        {actionButtons && (
          <SC.ButtonsWrapper withBorder={!!days}>
            {actionButtons?.map((button: ActionButtonProps) => (
              <SC.Button key={button?.text} {...button} />
            ))}
          </SC.ButtonsWrapper>
        )}
        {days && (
          <SC.DaysWrapper>
            {days?.map((day: DayButtonProps) => (
              <SC.DayBtn
                showDate={!isEarlierPlanning}
                key={day?.number}
                {...day}
              />
            ))}
          </SC.DaysWrapper>
        )}
      </SC.Inner>
    </SC.Collapse>
  )
}

export default PlanningPlannerSection
